import GalaxyHeaderSettings from "./GalaxyHeaderSettings";
import React, { useState, useEffect } from 'react';
import Sidebars from '../../components/sidebars/Sidebars';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import SocialLinksForm from './SocialLinksForm';
import SocialLinksTable from './SocialLinksTable';
import { toast } from 'react-toastify';
import axios from 'axios';
import Loader from '../../components/Loader';
import {GetUrl} from "../../config/GetUrl";
const SocialLinks = () => {
  const [showLoader, setShowLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [socialLinks, setSocialLinks] = useState([]);

  useEffect(() => {
    fetchSocialLinks();
  }, []);
  const fetchSocialLinks = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${GetUrl.API_URL}/api/v1/Admin/getAllSocialLinks`, {
        headers: {
          'authorization': `Bearer ${localStorage.getItem('tokenAdmin')}`
        }
      });
      if (response.data.status) {
        setSocialLinks(response.data.data);
      }
        setIsLoading(true);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error fetching social links');
        setIsLoading(true);
    } finally {
      setIsLoading(false);
    }
  };
  const handleAddSocialLink = async (formData) => {
    try {
      setShowLoader(true);
       setShowForm(false);
      const data = new FormData();
      data.append('name', formData.name);
      data.append('link', formData.url);
      if (formData.image) {
        data.append('image', formData.image);
      }

      if (editingIndex !== null) {
        // Update existing social link
        const response = await axios.put(
          `${GetUrl.API_URL}/api/v1/Admin/updateSocialLink/${socialLinks[editingIndex]._id}`,
          data,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'authorization': `Bearer ${localStorage.getItem('tokenAdmin')}`
            }
          }
        );
        
        if (response.data.status) {
          toast.success('Social link updated successfully');
          fetchSocialLinks();
        }
      } else {
        // Create new social link
        const response = await axios.post(
          `${GetUrl.API_URL}/api/v1/Admin/createSocialLink`,
          data,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'authorization': `Bearer ${localStorage.getItem('tokenAdmin')}`
            }
          }
        );
        
        if (response.data.status) {
          toast.success('Social link created successfully');
          fetchSocialLinks();
        }
      }
      
      setShowForm(false);
      setEditingIndex(null);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error saving social link');
       setShowForm(true);
    } finally {
      setShowLoader(false);
    }
  };
  const handleEdit = (index) => {
    setEditingIndex(index);
    setShowForm(true);
  };
  const handleDelete = async (index) => {
    try {
      setShowLoader(true);
      
      const response = await axios.delete(
        `${GetUrl.API_URL}/api/v1/Admin/deleteSocialLink/${socialLinks[index]._id}`,
        {
          headers: {
            'authorization': `Bearer ${localStorage.getItem('tokenAdmin')}`
          }
        }
      );
      
      if (response.data.status) {
        toast.success('Social link deleted successfully');
        fetchSocialLinks();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error deleting social link');
    } finally {
      setShowLoader(false);
    }
  };
  const handleClose = () => {
    setShowForm(false);
    setEditingIndex(null);
  };
  const AddSocialLinkHandler = () => {
    setEditingIndex(null);
    setShowForm(true);
  };

  return (
    <>
      <Sidebars />
      <Header />
      <main id="main" className="main mt-0 h-100 min-vh-80">
        <div className="pagetitle">
          <div className="d-flex justify-content-between align-items-center mb-3 mobile-block">
            <div className="d-flex gap-4 mobile-block">
              <div className="div">
                <h1>Website Header & Chat</h1>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item"><a href="">Home</a></li>
                    <li className="breadcrumb-item active">Website Header & Chat</li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className="">
              <button className="btn btn-main me-2" onClick={AddSocialLinkHandler}>
                <i className="bi bi-plus-lg me-2"></i>Add Social Link
              </button>
            </div>
          </div>
        </div>

        {(isLoading || showLoader) && <Loader />}

        <GalaxyHeaderSettings />
      </main>
      <Footer />
    </>
  );
};

export default SocialLinks; 